CouponCard = require './coupon_card'

$ ->
  $couponCards = $ '#multiple-offers .mpp-coupon-card'
  return unless $couponCards.length > 0

  for el in $couponCards
    new CouponCard(el)

  # We load ZeroClipboard like this so that we only load it when there
  # are coupons on the page, and to avoid adding extra weight to our main JS.
  script = document.createElement 'script'
  script.src = $('#multiple-offers').data 'zero-clipboard-js'
  firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore script, firstScript
